var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GraphicCard',{attrs:{"chart-id":"pie-experiences","title":"Tipos de experiencias","chart-type":"pie","label":"Identifica los tipos y cantidad de experiencias en tus proyectos","option":_vm.pieOption}})}
var staticRenderFns = []

export { render, staticRenderFns }